import * as React from 'react';
import { Dialog, Button, DialogTitle, Typography, DialogActions, DialogContent, Stack, Box } from '@mui/material';
import { withStyles } from '../../settings/styles';
import { WithTranslation, withTranslation } from 'react-i18next';
import { SvgIconComponent } from '@mui/icons-material';

interface State {};

interface Props extends WithTranslation
{
    title: string;
    icon?: SvgIconComponent;
    open: boolean;
    zIndex?: number;
    onClose: ()=>void;
    actions?: {
        id: string;
        title: string;
        icon?: SvgIconComponent;
        secondaryColor?: boolean;
        onAction: (id: string)=>void;
    }[]
}

class ResultDialog extends React.Component<Props, State>
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    render()
    {
        const { t } = this.props;
        const Icon = this.props.icon;
        return (<>
            <Dialog onClose={this.props.onClose} open={this.props.open}>
                <DialogTitle id="result-dialog-title" style={{paddingBottom: "5px"}}>
                    <Typography sx={{marginBottom: "30px"}}>
                        {Icon ? <Icon sx={{verticalAlign: "middle", marginRight: "15px"}} /> : <></>}
                        {this.props.title}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Stack>
                        {this.props.children}
                    </Stack>
                </DialogContent>
                <DialogActions sx={{justifyContent: 'space-between'}}>
                    <Box sx={{display: 'flex', justifyContent: 'left', ml: 1}}>
                    {
                        this.props.actions?.map(action=>{
                            const icon = action.icon ? <action.icon sx={{padding: '2px', pb: '4px'}} /> : <></>;
                             return (<Button key={`result-dialog-action-btn-${action.title}-${action.id}`} onClick={()=>action.onAction(action.id)} color={action.secondaryColor?"secondary":"primary"} sx={{mr: 1}} >
                                {icon}
                                {action.title}
                            </Button>)
                        })
                    }
                    </Box>
                    <Box sx={{display: 'flex', justifyContent: 'right', mr: 1}}>
                        <Button onClick={this.props.onClose} color="secondary" sx={{ml: 'auto'}}>
                            {`${t('dialogs.result.close')}`}
                        </Button>
                    </Box>
                    
                </DialogActions>
            </Dialog>
        </>);
    }
}

// ----------------- Export -----------------  //

export default withStyles(withTranslation()(ResultDialog));

// ------------------------------------------  //